import  types from './all-mutation-types'
import Vue  from 'vue'
import { MutationTree } from 'vuex/types'
import { ICatalogueState } from './state'
import { AloBase } from '@/models/alo/AloBase'
import { AloFamille } from '@/models/alo/AloFamille'
import { toNumberDictionary } from '@/utils/groupBy'
import { buildStateItem } from '@/models/alo/StateItem'
import { AloCatalogReference } from '@/models/alo/AloCatalogReference'
import { AloCatalogTree } from '@/models/alo/AloCatalogTree'
import { AloMeta } from '@/models/alo/AloMeta'
import { AloFluxBuilder } from '@/models/alo/AloFluxBuilder'
import { AloMarque } from '@/models/alo/AloMarque'

const mutations: MutationTree<ICatalogueState> = {
    [types.CATALOGUE_MARQUE_REQUEST]: state => {    
        state.marqueStatus = 'loading'
    },
    [types.CATALOGUE_MARQUE_SUCCESS]: (state, marques:Array<AloMarque>) => {    
        marques.forEach(m => Object.freeze(m))
        state.marques = {...state.marques, ...toNumberDictionary(marques,m => m.id)}
        state.marquesList = buildStateItem(marques.map(m => m.id))
        state.marqueStatus = 'completed'
    },
    [types.CATALOGUE_MARQUE_ERROR]: state => {        
        state.marqueStatus = 'error'    
    },
    [types.CATALOGUE_REFERENCE_REQUEST]: state => {    
        state.referenceStatus = 'loading'
    },
    [types.CATALOGUE_REFERENCE_SUCCESS]: (state, refecence:AloCatalogReference) => {        
        state.dispos = {...state.dispos, ...toNumberDictionary(refecence.catalogDispo,c => c.id)}
        state.disposList = buildStateItem(refecence.catalogDispo.map(c => c.id))

        state.enseignes = {...state.enseignes, ...toNumberDictionary(refecence.catalogEnseigne,c => c.id)}
        state.enseignesList = buildStateItem(refecence.catalogEnseigne.map(c => c.id))        

        state.transporters = {...state.transporters, ...toNumberDictionary(refecence.catalogTransporter,c => c.id)}
        state.transportersList = buildStateItem(refecence.catalogTransporter.map(c => c.id))
        
        state.tarifModels = {...state.tarifModels, ...toNumberDictionary(refecence.catalogTarifModel,c => c.id)}
        state.tarifModelsList = buildStateItem(refecence.catalogTarifModel.map(c => c.id))  

        state.statutCompactGroups = {...state.statutCompactGroups, ...toNumberDictionary(refecence.catalogStatutCompactGroup,c => c.id)}
        state.statutCompactGroupsList = buildStateItem(refecence.catalogStatutCompactGroup.map(c => c.id))
        
        state.fluxBuilders = {...state.fluxBuilders, ...toNumberDictionary(refecence.fluxBuilder,f => f.id)}
        state.fluxBuildersList = buildStateItem(refecence.fluxBuilder.map(f => f.id))

        state.fluxRestrictedFlag = refecence.fluxRestrictedFlag

        state.metas = {...state.metas, ...toNumberDictionary(refecence.meta,m => m.id)}
        state.metasList = buildStateItem(refecence.meta.map(m => m.id))

        state.metaGroups = {...state.metaGroups, ...toNumberDictionary(refecence.metaGroup,m => m.id)}
        state.metaGroupsList = buildStateItem(refecence.metaGroup.map(m => m.id))

        state.partRestrictedFlag = refecence.partRestrictedFlag
                
        state.referenceStatus = 'completed'
    },
    [types.CATALOGUE_REFERENCE_ERROR]: state => {        
        state.referenceStatus = 'error'    
    },
    [types.CATALOGUE_TREE_REQUEST]: state => {    
        state.categoriesStatus = 'loading'
    },
    [types.CATALOGUE_TREE_SUCCESS]: (state, tree:AloCatalogTree) => {        
        state.univers = {...state.univers, ...toNumberDictionary(tree.univers,u => u.id)}
        state.universList = buildStateItem(tree.univers.filter(u => u.uniIsAlive).map(u => u.id))
        
        state.rubriques = {...state.rubriques, ...toNumberDictionary(tree.rubriques,r => r.id)}
        state.rubriquesList = buildStateItem(tree.rubriques.filter(r => r.rubIsAlive).map(r => r.id))
                
        state.familles = {...state.familles, ...tree.familles.reduce(function(dicFam, f) {      
            f.uniId = state.rubriques[f.rubId].uniId
            dicFam[f.id] = f
            return dicFam
          }, {} as {[index: number]: AloFamille})}
        state.famillesList = buildStateItem(tree.familles.filter(f => f.famIsAlive).map(f => f.id))
        
        state.categoriesStatus = 'completed'
    },
    [types.CATALOGUE_TREE_ERROR]: state => {        
        state.categoriesStatus = 'error'    
    },
    [types.CATALOGUE_META_REQUEST]: state => {    
        state.metasStatus = 'Chargement des metas'
    },
    [types.CATALOGUE_META_SUCCESS]: (state, metas:Array<AloMeta>) => {        
        state.metas = {...state.metas, ...toNumberDictionary(metas,m => m.id)}
        state.metasList = buildStateItem(metas.map(m => m.id))
        state.metasStatus = 'Chargement des metas terminé'
    },
    [types.CATALOGUE_META_ERROR]: state => {        
        state.metasStatus = 'Erreur lors du chargement des metas'    
    },
    [types.CATALOGUE_META_DETAIL_REQUEST]: state => {    
        state.metasStatus = 'Chargement du detail metas'
    },
    [types.CATALOGUE_META_DETAIL_SUCCESS]: (state, metas:AloMeta) => {           
        metas.newId = metas.id
        Vue.set(state.metas,metas.id,metas)
        state.metasStatus = 'Chargement du detail metas terminé'
    },
    [types.CATALOGUE_META_DETAIL_ERROR]: state => {        
        state.metasStatus = 'Erreur lors du chargement du detail metas'    
    },
    [types.CATALOGUE_META_SAVE_REQUEST]: state => {    
        state.metasStatus = 'Sauvegarde du metas'
    },
    [types.CATALOGUE_META_SAVE_SUCCESS]: (state, metas:AloMeta) => {                
        if(metas.newId != 0 && metas.newId != metas.id){
            state.metasList.item.splice(state.metasList.item.indexOf(metas.newId) ,1,metas.id)
            delete state.metas[metas.newId]    
        }
        metas.newId = metas.id
        Vue.set(state.metas,metas.id,metas)
        state.metasStatus = 'Sauvegarde du metas terminée'
    },
    [types.CATALOGUE_META_SAVE_ERROR]: state => {        
        state.metasStatus = 'Erreur lors de la sauvegarde du metas'
    }, 
    [types.CATALOGUE_META_RESET_STATUS]: (state) => {
      state.metasStatus = ''
    },
    [types.CATALOGUE_META_DELETE_REQUEST]: state => {    
        state.metasStatus = 'Suppression du meta'
    },
    [types.CATALOGUE_META_DELETE_SUCCESS]: (state, metas:AloMeta) => {        
        state.metasList.item.splice(state.metasList.item.indexOf(metas.id) ,1)
        delete state.metas[metas.id]                
        state.metasStatus = 'Suppression du dataSources terminée'
    },
    [types.CATALOGUE_META_DELETE_ERROR]: state => {        
        state.metasStatus = 'Erreur lors de la Suppression du dataSources'
    },
    [types.CATALOGUE_FLUXBUILDER_REQUEST]: state => {    
        state.fluxBuildersStatus = 'Chargement des flux builders'
    },
    [types.CATALOGUE_FLUXBUILDER_SUCCESS]: (state, fluxBuilders:Array<AloFluxBuilder>) => {        
        state.fluxBuilders = {...state.fluxBuilders, ...toNumberDictionary(fluxBuilders,m => m.id)}
        state.fluxBuildersList = buildStateItem(fluxBuilders.map(m => m.id))
        state.fluxBuildersStatus = 'Chargement des fluxBuilders terminé'
    },
    [types.CATALOGUE_FLUXBUILDER_ERROR]: state => {        
        state.fluxBuildersStatus = 'Erreur lors du chargement des flux builders'    
    },
    [types.CATALOGUE_FLUXBUILDER_DETAIL_REQUEST]: state => {    
        state.fluxBuildersStatus = 'Chargement du detail flux builder'
    },
    [types.CATALOGUE_FLUXBUILDER_DETAIL_SUCCESS]: (state, fluxBuilders:AloFluxBuilder) => {           
        fluxBuilders.newId = fluxBuilders.id
        Vue.set(state.fluxBuilders,fluxBuilders.id,fluxBuilders)
        state.fluxBuildersStatus = 'Chargement du detail flux builder terminé'
    },
    [types.CATALOGUE_FLUXBUILDER_DETAIL_ERROR]: state => {        
        state.fluxBuildersStatus = 'Erreur lors du chargement du detail flux builder'    
    },
    [types.CATALOGUE_FLUXBUILDER_SAVE_REQUEST]: state => {    
        state.fluxBuildersStatus = 'Sauvegarde du flux Builder'
    },
    [types.CATALOGUE_FLUXBUILDER_SAVE_SUCCESS]: (state, fluxBuilders:AloFluxBuilder) => {                
        if(fluxBuilders.newId != 0 && fluxBuilders.newId != fluxBuilders.id){
            state.fluxBuildersList.item.splice(state.fluxBuildersList.item.indexOf(fluxBuilders.newId) ,1,fluxBuilders.id)
            delete state.fluxBuilders[fluxBuilders.newId]    
        }
        fluxBuilders.newId = fluxBuilders.id
        Vue.set(state.fluxBuilders,fluxBuilders.id,fluxBuilders)
        state.fluxBuildersStatus = 'Sauvegarde du flux builder terminée'
    },
    [types.CATALOGUE_FLUXBUILDER_SAVE_ERROR]: state => {        
        state.fluxBuildersStatus = 'Erreur lors de la sauvegarde du flux builder'
    }, 
    [types.CATALOGUE_FLUXBUILDER_RESET_STATUS]: (state) => {
      state.fluxBuildersStatus = ''
    },
    [types.CATALOGUE_FLUXBUILDER_DELETE_REQUEST]: state => {    
        state.fluxBuildersStatus = 'Suppression du flux builder'
    },
    [types.CATALOGUE_FLUXBUILDER_DELETE_SUCCESS]: (state, fluxBuilders:AloFluxBuilder) => {        
        state.fluxBuildersList.item.splice(state.fluxBuildersList.item.indexOf(fluxBuilders.id) ,1)
        delete state.fluxBuilders[fluxBuilders.id]                
        state.fluxBuildersStatus = 'Suppression du flux builder terminée'
    },
    [types.CATALOGUE_FLUXBUILDER_DELETE_ERROR]: state => {        
        state.fluxBuildersStatus = 'Erreur lors de la Suppression du flux builder'
    }
}

export default mutations